import React, { useState } from 'react';
import LocationScheduleView from './LocationScheduleView';
import './LocationCard.css';

const LocationCard = ({ 
  location, 
  onEdit, 
  onDelete, 
  onClick,
  compact = false,
  showSchedulesProp = true 
}) => {
  const [showSchedules, setShowSchedules] = useState(false);

  const handleCardClick = (e) => {
    // No hacer click si se clickeó en un botón
    if (e.target.tagName === 'BUTTON' || e.target.closest('button')) {
      return;
    }
    if (onClick) {
      onClick(location);
    }
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit(location);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(location);
    }
  };

  const toggleSchedules = (e) => {
    e.stopPropagation();
    setShowSchedules(!showSchedules);
  };

  const formatAddress = (address) => {
    if (!address) return 'Dirección no especificada';
    const parts = [address.street, address.city, address.state].filter(Boolean);
    return parts.join(', ');
  };

  const formatCost = (cost) => {
    if (!cost || cost === 0) return 'No especificado';
    return `$${cost}`;
  };

  const getScheduleSummary = (schedules) => {
    if (!schedules || schedules.length === 0) return 'Sin horarios';
    const activeSchedules = schedules.filter(s => s.is_active);
    if (activeSchedules.length === 0) return 'Sin horarios activos';
    return `${activeSchedules.length} horario${activeSchedules.length > 1 ? 's' : ''} activo${activeSchedules.length > 1 ? 's' : ''}`;
  };

  return (
    <div 
      className={`location-card ${compact ? 'compact' : ''} ${onClick ? 'clickable' : ''}`}
      onClick={handleCardClick}
    >
      <div className="location-header">
        <h3>{location.name}</h3>
        <div className="location-actions">
          {showSchedulesProp && location.practice_schedules?.length > 0 && (
            <button 
              onClick={toggleSchedules}
              className="btn btn-info btn-sm"
              title={showSchedules ? 'Ocultar horarios' : 'Ver horarios'}
            >
              {showSchedules ? '📅' : '📅'}
            </button>
          )}
          {onEdit && (
            <button 
              onClick={handleEdit}
              className="btn btn-secondary btn-sm"
              title="Editar ubicación"
            >
              ✏️
            </button>
          )}
          {onDelete && (
            <button 
              onClick={handleDelete}
              className="btn btn-danger btn-sm"
              title="Eliminar ubicación"
            >
              🗑️
            </button>
          )}
        </div>
      </div>

      <div className="location-details">
        <div className="detail-item">
          <strong>📍 Dirección:</strong> 
          <span>{formatAddress(location.address)}</span>
        </div>
        
        {location.instructor_info?.name && (
          <div className="detail-item">
            <strong>👨‍🏫 Instructor:</strong> 
            <span>{location.instructor_info.name}</span>
          </div>
        )}

        <div className="detail-item">
          <strong>⏰ Horarios:</strong> 
          <span>{getScheduleSummary(location.practice_schedules)}</span>
        </div>

        <div className="detail-item">
          <strong>💰 Costo Mensual:</strong> 
          <span>{formatCost(location.monthly_cost)}</span>
        </div>

        {location.class_cost && location.class_cost > 0 && (
          <div className="detail-item">
            <strong>💵 Costo por Clase:</strong> 
            <span>{formatCost(location.class_cost)}</span>
          </div>
        )}

        {location.instructor_info?.credentials && (
          <div className="detail-item">
            <strong>🏆 Credenciales:</strong> 
            <span>{location.instructor_info.credentials}</span>
          </div>
        )}

        {location.instructor_info?.experience && location.instructor_info.experience > 0 && (
          <div className="detail-item">
            <strong>📚 Experiencia:</strong> 
            <span>{location.instructor_info.experience} años</span>
          </div>
        )}
      </div>

      {showSchedulesProp && location.practice_schedules?.length > 0 && (
        <div className="location-schedules">
          <LocationScheduleView 
            schedules={location.practice_schedules}
            compact={true}
          />
        </div>
      )}
    </div>
  );
};

export default LocationCard;
